export default __webpack_public_path__ + "static/media/TRASFERTE_ICONA.5559f10b.svg";